// tslint:disable
export enum DocumentGroupSource {
    /**
     * @description UNKNOWN
     */
    UNKN = 0,
    /**
     * @description WEB
     */
    WEB = 1,
    /**
     * @description Incoming Mail
     */
    InMail = 2,
    /**
     * @description Incoming Fax
     */
    Infax = 3,
    /**
     * @description Incoming Email
     */
    Inemail = 4,
    /**
     * @description FEED
     */
    FEED = 5,
    /**
     * @description UPLOAD FROM APPLICATIONS
     */
    UPD = 6,
    /**
     * @description Outgoing Mail
     */
    OutMail = 7,
    /**
     * @description Outgoing Fax
     */
    OutFax = 8,
    /**
     * @description Outgoing Email
     */
    OutEmail = 9,
    /**
     * @description Migration Document
     */
    Mig = 10,
    /**
     * @description Phone
     */
    Phone = 11,
    /**
     * @description Web Service
     */
    WebService = 12,
    /**
     * @description Data Feed
     */
    DataFeed = 13,
    /**
     * @description TrialCard Portal
     */
    TCPortal = 14,
    /**
     * @description System Created
     */
    SystemCreated = 15,
    /**
     * @description Mail
     */
    Mail = 16,
    /**
     * @description Fax
     */
    Fax = 17,
    /**
     * @description Email
     */
    Email = 18,
    /**
     * @description SMS
     */
    SMS = 19,
    /**
     * @description TC Script
     */
    TCScript = 20,
    /**
     * @description DocuSign
     */
    DocuSign = 21,
    /**
     * @description CoverMyMeds
     */
    CMM = 22,
}
(DocumentGroupSource as any)['INMAIL'] = 2;
(DocumentGroupSource as any)['INFAX'] = 3;
(DocumentGroupSource as any)['INEMAIL'] = 4;
(DocumentGroupSource as any)['OUTMAIL'] = 7;
(DocumentGroupSource as any)['OUTFAX'] = 8;
(DocumentGroupSource as any)['OUTEMAIL'] = 9;
(DocumentGroupSource as any)['MIG'] = 10;
(DocumentGroupSource as any)['PHONE'] = 11;
(DocumentGroupSource as any)['WEBSERVICE'] = 12;
(DocumentGroupSource as any)['DATAFEED'] = 13;
(DocumentGroupSource as any)['TCPORTAL'] = 14;
(DocumentGroupSource as any)['SYSTEMCREATED'] = 15;
(DocumentGroupSource as any)['MAIL'] = 16;
(DocumentGroupSource as any)['FAX'] = 17;
(DocumentGroupSource as any)['EMAIL'] = 18;
(DocumentGroupSource as any)['TCSCRIPT'] = 20;
(DocumentGroupSource as any)['DOCUSIGN'] = 21;
